/* eslint-disable max-len */
import jLogin from '@/views/login/jLogin';
import jLoginLdap from '@/views/login/jLoginLdap';
import mainConstant from '@jojocoders/jojonomic-ui/src/Utils/constant';
import Vue from 'vue';

export default [
  {
    path: '/',
    name: 'jLogin',
    component: jLogin,
    beforeEnter(to, from, next) {
      if (Vue.ls.get('Token')) {
        const middlewareRole = localStorage.getItem('userRole');
        if (middlewareRole && (Number(middlewareRole) === 1 || Number(middlewareRole) === 2)) {
          next('/setting/application');
        } else {
          localStorage.clear();
          next('/denied');
        }
      } else {
        next();
      }
    },
    meta: {
      title: 'Login',
    },
  },
  {
    path: '/signin-with-ldap',
    name: 'jLoginLdap',
    component: jLoginLdap,
    beforeEnter(to, from, next) {
      if (Vue.ls.get('Token')) {
        const middlewareRole = JSON.parse(localStorage.getItem('role'));
        if (middlewareRole.includes(mainConstant.RoleAdmin) || middlewareRole.includes(mainConstant.RoleSysadmin)) {
          next('/setting/application');
        } else {
          localStorage.clear();
          next('/denied');
        }
      } else {
        next();
      }
    },
    meta: {
      title: 'Login with Active Directory',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterLogin.js